<template>
	<div class="subBanner-content">
		<el-carousel arrow="never" indicator-position="none" trigger="click" :autoplay="false" :height="bannerHeight + 'px'" :width="bannerWidth + 'px'">
			<el-carousel-item>
				<div class="headline">
					<div class="title">
						{{bannerContent.name}}
					</div>
					<div class="description">
						{{bannerContent.description}}
					</div>
					<div class="button">
						<span @click="enterSingup(bannerContent.id)">在线签约</span>	
					</div>
				</div>
				<img ref="bannerImg" :src="channelInfo.image">
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import { queryProductByType } from '@/api/channel/product.js'
	import { queryChannelInfoByID } from '@/api/channel/channel.js'
	export default {
		data() {
			return {
				bannerHeight: '', // 图片父容器高度
				bannerWidth: '', //图片父容器宽度
				id: 0,//产品id
				productList: [],//商品列表
				bannerContent: {},//轮播图内容
				channelId: '',//栏目id
				channelInfo: {},//栏目详情
			}
		},
		props: ['productId'],
		mounted() {
			// this.queryBannerImage()
			this.getData();
		},
		watch: {
			productId: function(val) {
        this.productId = val;
        this.getData();
			},
      bannerContent: function(val) {
				this.bannerContent = val;
			}
    },
		methods: {
			async getData() {
				if(this.productId) {
					this.id = this.productId;
				} else {
					let index = window.location.href.lastIndexOf("=");
      		let str = window.location.href.substring(index + 1);
      		this.id = str - 0;
				}
				//查询商品列表
				let type = 0;
        let res = await queryProductByType(type);
				this.productList = res.data.list;
				this.productList.forEach((e) => {
					if(e.id == this.id) {
						this.bannerContent = e;
					}
				})
				this.queryChannelInfo();
			},
			//查询背景图
			async queryChannelInfo() {
				if(this.$route.query.channelId) {
					this.channelId = this.$route.query.channelId;
				} else {
					this.channelId = window.location.href.substr(window.location.href.lastIndexOf('/') + 1, 2);
				}
				let result = await queryChannelInfoByID(this.channelId);
				this.channelInfo = result.data;
			},
			//进入在线签约页面
			enterSingup(id) {
				this.$router.push({path: '/onlineSignup',query: {id: id}})
			},
			// queryBannerImage(){
			// 	queryImageByStatus('N').then(data => {
			// 		this.imgList=data.data.list
			// 		this.imgLoad();
			// 	}).catch(error =>{
			// 		this.$message.error(error)
			// 	})
			// },
			// imgLoad() {
			// 	this.$nextTick(() => {
			// 		this.bannerHeight = this.$refs.bannerImg[0].height;
			// 		this.bannerWidth = this.$refs.bannerImg[0].width;
			// 	})
			// },
		},

	}
</script>


<style lang="scss">
	.subBanner-content{
		.el-carousel__container{
			height: 350px;
			.el-carousel__item{
				height: 350px;
				.headline{
					height: 350px;
					left: 300px;
					position: absolute;
					display: flex;
					justify-content: center;
					flex-direction: column;
					z-index: 1;
					.title{
						font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
						font-weight: 700;
						font-style: normal;
						font-size: 40px;
						color: #3B3B3B;
					}
					.description{
						padding-right: 300px;
						margin: 10px 0;
					}
					.button{
						margin-top: 30px;
						span{
							display: inline-block;
							width: 150px;
							height: 35px;
							border-radius: 5px;
							color: white;
							line-height: 35px;
							text-align: center;
							background-color: #507df1;
						}
						span:hover{
							cursor: pointer;
						}
					}
				}
				img{
					width: 100%;
					height: 350px;
					filter: opacity(50%);
				}
			}
		}		
		
	}
	
	
</style>
<style lang="scss" scoped>
	.subBanner-content {
		margin-top: 81px;
		min-width: 1330px;
	}
</style>
